/** Shared helpers for entries ticker / dashboard recent entries. */

export function sharpScoreToUnit(sharp) {
  if (sharp == null) return null;
  const n = typeof sharp === 'number' ? sharp : parseFloat(String(sharp).trim());
  if (!Number.isFinite(n)) return null;
  const u = n > 1.0 + 1e-9 ? n / 100.0 : n;
  return Math.max(0, Math.min(1, u));
}

/** 0 = green, 1 = red; null = no fill. */
export function getSharpColor(sharp) {
  const t = sharpScoreToUnit(sharp);
  if (t == null) return null;
  const r = Math.round(16 + (239 - 16) * t);
  const g = Math.round(185 - (185 - 68) * t);
  const b = Math.round(129 - (129 - 68) * t);
  return `rgb(${r},${g},${b})`;
}

export function getSharpTextColor(sharp) {
  const t = sharpScoreToUnit(sharp);
  if (t == null) return 'inherit';
  return t >= 0.55 ? '#fff' : 'inherit';
}

export function entryPromoRowClass(row) {
  const norm = (s) => String(s || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  const lineKind = norm(row?.line_type);
  if (lineKind === 'line_promotion') return 'entries-row--line-promo';

  const promo = norm(row?.promo_type);
  if (promo === 'profit_boost' || (promo.includes('profit') && promo.includes('boost'))) {
    return 'entries-row--profit-boost';
  }
  if (row?.profit_boost_percentage != null && Number(row.profit_boost_percentage) > 0) {
    return 'entries-row--profit-boost';
  }
  if (promo === 'protected_pick' || promo.includes('protected')) {
    return 'entries-row--protected-pick';
  }
  if (promo === 'free_picks_entry' || promo.includes('free_pick')) {
    return 'entries-row--free-picks';
  }
  if (promo) return 'entries-row--promo-other';
  return null;
}

export function formatReplicationBadge(row) {
  const nReg = row?.replication_n_reg;
  const nHf = row?.replication_n_hf;
  if (nReg == null && nHf == null) return null;
  const parts = [];
  if (nReg != null && Number(nReg) > 0) parts.push(`${Number(nReg)}r`);
  if (nHf != null && Number(nHf) > 0) parts.push(`${Number(nHf)}h`);
  return parts.length ? parts.join('·') : null;
}

export function sharpCellStyle(sharp) {
  const bg = getSharpColor(sharp);
  if (!bg) return undefined;
  return { backgroundColor: bg, color: getSharpTextColor(sharp) };
}
